import Api from "../api/api";
import {useEffect,useState,useRef} from "react";
import Enums from "../../utilities/enum";
import {saveAs} from 'file-saver';
import Loader from "../shared/loader";
import {EmptyState} from "../dashboard/emptyState";
import arrayUtilities from "../../utilities/arrayUtilities";
import {toDateString} from "../../utilities/dateUtilities";
import {FiltersModalTrigger} from "../shared/filtersModalTrigger";
import { AppliedFilterPill, renderTagFilterItemLabel } from "../shared/appliedFilterPill";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import {ExportBreachesReportFiltersModal} from "./filters-modals/exportBreachesReportFiltersModal";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import { downloadReportPdf } from "./downloadReportPdf";
import { PrintPdfHeader } from "./printPdfHeader";
import { ExportBreachesScheduleModal } from "./schedule-modals/exportBreachesScheduleModal";
export default function ExportBreachesReport({organisationId, token, tags, organisationName, organisationLogo}) {

    const [reportsData, setReportsData] = useState(null);
    const [singleDate, setSingleDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(true);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const [selectedTags, setSelectedTags] = useState([]);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [showScheduleExportModal, setShowScheduleExportModal] = useState(false);
    const reportsLandingUrl = `/organisation/${ organisationId }/reports`;
    const pdfRef = useRef()

    const pdfStatusName = (statusId) => Enums.BreachStatus[statusId]

    const fetchExportBreachesReports = (status, date, tagIds) => {
        setIsLoading(true);
        Api.getExportBreachReports(
            reportData => { setReportsData(reportData); setIsLoading(false) },
            () => setIsLoading(false),
            Number(status), date, 0, tagIds, organisationId, token
        )
    }

    const handleResetFilters = () => {
        const defaultDate = new Date();
        setSingleDate(defaultDate);
        setSelectedStatus(0);
        setSelectedTags([]);
        setAppliedFilters({
            "Date": toDateString(defaultDate),
            "Status": Enums.BreachStatus[0]
        });
        setShowFilterPills(true);
        fetchExportBreachesReports(0, defaultDate, []);
    }

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Date": {
                const defaultDate = new Date()
                setSingleDate(defaultDate)
                fetchExportBreachesReports(selectedStatus, defaultDate, selectedTags)
                break
            }
            case "Status":
                setSelectedStatus(0)
                fetchExportBreachesReports(0, singleDate, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                fetchExportBreachesReports(selectedStatus, singleDate, [])
                break
            default:
                break
        }
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "Date") {
                updatedFilters["Date"] = toDateString(new Date())
            } else if (closedLabel === "Status") {
                updatedFilters["Status"] = Enums.BreachStatus[0]
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                fetchExportBreachesReports(selectedStatus, singleDate, remainingIds)
                break
            default:
                break
        }
    }


    const scheduleInitialParameters = {
        from: singleDate,
        to: singleDate,
        breachStatus: selectedStatus,
        tagIds: selectedTags,
    }

    const closeScheduleExportModal = () => setShowScheduleExportModal(false)
    useEffect(() => {
        fetchExportBreachesReports(selectedStatus, singleDate, selectedTags);
        setAppliedFilters({
            "Date": toDateString(singleDate),
            "Status": Enums.BreachStatus[selectedStatus]
        });
        setShowFilterPills(true);
    }, [])

    const handleDownload = (outputFormat) => {
        Api.getExportBreachReports(
            (blob, filename) => { saveAs(blob, filename); },
            () => { setIsLoading(false) },
            Number(selectedStatus),
            singleDate,
            outputFormat,
            selectedTags,
            organisationId,
            token
        );
    }

    const selectedTagNames = !arrayUtilities.isNullOrEmpty(selectedTags) && !arrayUtilities.isNullOrEmpty(tags)
        ? selectedTags
            .map(selectedTagId => tags.find(tag => tag.id === selectedTagId))
            .filter(tag => tag !== undefined)
            .map(tag => tag.name)
            .join(", ")
        : "All"

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <h5 className="mb-0">
                                            Export Breaches
                                        </h5>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex mr-2 align-items-center">
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                        <button
                                            onClick={ () => handleDownload(1) }
                                            className="btn btn-sm btn-default text-white bg-dark nowrap mr-2"
                                        >
                                            Download CSV<i className="ml-2 fas fa-file-excel"></i>
                                        </button>
                                        <button
                                            onClick={ () => downloadReportPdf(pdfRef, `${ organisationName } - Export Breaches`) }
                                            className="btn btn-sm btn-default nowrap mr-2 text-white" style={ { backgroundColor: "#4A7C8E" } }
                                        >
                                            Download PDF<i className="ml-2 far fa-file-pdf"></i>
                                        </button>
                                        <button
                                            onClick={ () => setShowScheduleExportModal(true) }
                                            className="btn btn-sm btn-secondary nowrap mr-2"
                                        >
                                            Schedule Report<i className="ml-2 far fa-clock"></i>
                                        </button>
                                        <Link
                                            className="btn btn-falcon-default btn-sm mr-3"
                                            type="button"
                                            to={ reportsLandingUrl }>
                                            <i className="fas fa-reply"></i> Back
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body border-top d-flex flex-column">
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => {
                                                    const resettable = label === "Date" || label === "Status"
                                                    return <AppliedFilterPill
                                                        key={ label }
                                                        label={ label }
                                                        value={ value }
                                                        isResettable={ resettable }
                                                        renderItemLabel={ renderTagFilterItemLabel }
                                                        onTextClick={ () => setShowFiltersModal(true) }
                                                        onCloseClick={ handleFilterPillClose }
                                                        onRemoveItem={ handleFilterPillItemRemove }
                                                    />
                                                }
                                            )
                                        }
                                        { appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => handleResetFilters() }>Reset all filters</button> }
                                    </div>
                                }
                                <div ref={ pdfRef }>
                                    <PrintPdfHeader organisationLogo={ organisationLogo } organisationName={ organisationName } title="Export Breaches">
                                        <div className="print-only-filter">
                                            <span className="print-only-filter-label">Date</span>
                                            <span className="print-only-filter-value">
                                                { toDateString(singleDate) }
                                            </span>
                                        </div>
                                        <div className="print-only-filter">
                                            <span className="print-only-filter-label">Status</span>
                                            <span className="print-only-filter-value">
                                                { pdfStatusName(selectedStatus) }
                                            </span>
                                        </div>
                                        <div className="print-only-filter">
                                            <span className="print-only-filter-label">Tags</span>
                                            <span className="print-only-filter-value">
                                                { selectedTagNames }
                                            </span>
                                        </div>
                                    </PrintPdfHeader>
                                {
                                    isLoading
                                        ? <Loader />
                                        : <>
                                            {
                                                !arrayUtilities.isNullOrEmpty(reportsData) ? (<div className="mt-3 d-flex flex-column">
                                                        <div className="card-body bg-white border-top p-0">
                                                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                                                <thead className="bg-200 text-900">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>VRM</th>
                                                                    <th>Reference Number</th>
                                                                    <th>Site Name</th>
                                                                    <th>Entry Time</th>
                                                                    <th>Entry Date</th>
                                                                    <th>Exit Time</th>
                                                                    <th>Exit Date</th>
                                                                    <th>Duration</th>
                                                                    <th>Contravention</th>
                                                                </tr>
                                                                </thead>

                                                                <tbody>
                                                                {
                                                                    reportsData.map(item => <tr key={item.index}>
                                                                        <td>{item.index + 1}</td>
                                                                        <td>{item.vrm}</td>
                                                                        <td>{item.referenceNumber}</td>
                                                                        <td>{item.siteName}</td>
                                                                        <td>{item.entryTime}</td>
                                                                        <td>{item.entryDate}</td>
                                                                        <td>{item.exitTime}</td>
                                                                        <td>{item.exitDate}</td>
                                                                        <td>{item.duration}</td>
                                                                        <td>{item.contravention}</td>
                                                                    </tr>
                                                                    )
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>) : <EmptyState message="No Data available for the selected filters"/>}
                                        </>}
                                </div>
            {
                showScheduleExportModal &&
                <ExportBreachesScheduleModal
                    tags={ tags || [] }
                    organisationId={ organisationId }
                    token={ token }
                    initialParameters={ scheduleInitialParameters }
                    onCancel={ closeScheduleExportModal }
                    onSaved={ closeScheduleExportModal }
                />
            }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showFiltersModal &&
                <ExportBreachesReportFiltersModal
                    showModal={ showFiltersModal }
                    handleClose={ () => setShowFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setSingleDate(draftFilters.singleDate)
                        setSelectedStatus(draftFilters.selectedStatus)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        fetchExportBreachesReports(draftFilters.selectedStatus, draftFilters.singleDate, draftFilters.selectedTags)
                    } }
                    initialSingleDate={ singleDate }
                    initialSelectedStatus={ selectedStatus }
                    initialSelectedTags={ selectedTags }
                    initialAppliedFilters={ appliedFilters }
                    tags={ tags || [] }
                    key="export-breaches-report-filters-modal"
                />
            }
        </>
    )
}
